import clsx from "clsx";
import PropTypes from "prop-types";
import * as React from "react";
import {
  resolveInteractiveElement,
  resolveActiveProps,
} from "../../utils/resolveElement";
import css from "./NavigationRail.module.css";

const NavigationRailRoot = React.forwardRef(
  ({ label = "Main", className, children, ...rest }, ref) => (
    <nav
      ref={ref}
      aria-label={label}
      className={clsx(css.root, className)}
      {...rest}
    >
      {children}
    </nav>
  ),
);

NavigationRailRoot.displayName = "NavigationRailRoot";

NavigationRailRoot.propTypes = {
  label: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
};

const NavigationRailFAB = React.forwardRef(
  ({ className, children, ...rest }, ref) => (
    <div ref={ref} className={clsx(css.fab, className)} {...rest}>
      {children}
    </div>
  ),
);

NavigationRailFAB.displayName = "NavigationRailFAB";

NavigationRailFAB.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
};

const NavigationRailItem = React.forwardRef(
  ({ href, active = false, icon, label, onClick, className, ...rest }, ref) => {
    const Element = resolveInteractiveElement({ href });
    const activeProps = resolveActiveProps({ href, active });

    return (
      <Element
        ref={ref}
        href={href}
        onClick={onClick}
        type={href ? undefined : "button"}
        className={clsx(css.item, className)}
        data-active={active || undefined}
        {...activeProps}
        {...rest}
      >
        <span className={css.itemIcon}>{icon}</span>
        <span className={css.itemLabel}>{label}</span>
      </Element>
    );
  },
);

NavigationRailItem.displayName = "NavigationRailItem";

NavigationRailItem.propTypes = {
  href: PropTypes.string,
  active: PropTypes.bool,
  icon: PropTypes.node.isRequired,
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  className: PropTypes.string,
};

const NavigationRail = {
  Root: NavigationRailRoot,
  FAB: NavigationRailFAB,
  Item: NavigationRailItem,
};

export default NavigationRail;
